import { render } from "./menu-abstract.vue?vue&type=template&id=8d1bce38"
import script from "./menu-abstract.vue?vue&type=script&lang=js"
export * from "./menu-abstract.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__